
import { Component, Prop, Vue } from 'vue-property-decorator'
import { isGlamping } from '~/utility/glamping'

@Component
export default class SearchSummaryBookableCountSearch extends Vue {
  @Prop()
  bookableCount: number

  @Prop()
  categoryIds?: string[]

  @Prop()
  distance: object

  @Prop()
  searchPlace: string

  @Prop()
  hierarchyName: string

  @Prop()
  categoryName?: string

  @Prop()
  isUserLocationSearch: boolean

  get isGlamping() {
    return isGlamping(this.categoryIds)
  }

  get formattedCategoryName() {
    return this.categoryName && this.categoryName.toLowerCase()
  }

  get place() {
    return this.hierarchyName || this.searchPlace
  }
}
